import React from 'react';
import {
  LandingGrid,
  LandingLayoutContent
} from '../../../common/components/Layout/Layout';
import { TextLink } from '../../../common/components/ui/TextLink/TextLink';
import personSrcUrp from '../../../assets/img/welcome/urp_person.png';
import personSrcOrp from '../../../assets/img/welcome/orp_person.png';
import personSrcHrFirst from '../../../assets/img/welcome/hr_first_person.png';
import personSrcHrSecond from '../../../assets/img/welcome/hr_second_person.png';
import {
  ContactsCard,
  ContactsCardPerson,
  ContactsCardSectionProps
} from './ContactsCard';
import s from './Contacts.module.scss';

export interface ContactsGridProps {
  title: string;
  cardSections: ContactsCardSectionProps[];
}

const mainContact: ContactsGridProps[] = [
  {
    title: 'Управление по работе с персоналом (УРП)',
    cardSections: [
      {
        title: (
          <ContactsCardPerson
            avatarSrc={personSrcUrp}
            profession={'Начальник управления'}
            name={'Бельчич Алексей Юрьевич'}
          />
        ),
        contacts: [
          {
            title: 'Телефон',
            content: '+7 (498) 713-91-98'
          },
          {
            title: 'Почта',
            content: (
              <TextLink noUnderline href={'mailto:belchich.ay@mipt.ru'}>
                belchich.ay@mipt.ru
              </TextLink>
            )
          },
          {
            title: 'Кампус',
            content: 'Аудиторный корпус, каб. 321'
          }
        ]
      }
    ]
  }
];

const contactsTemp: ContactsGridProps[] = [
  {
    title: 'Отдел развития персонала',
    cardSections: [
      {
        title: (
          <ContactsCardPerson
            avatarSrc={personSrcOrp}
            profession={'Начальник отдела'}
            name={'Бекасова Марина Геннадьевна'}
          />
        ),
        contacts: [
          {
            title: 'Телефон',
            content: '+7 (498) 744‒65‒42'
          },
          {
            title: 'Почта',
            content: (
              <TextLink noUnderline href={'mailto:bekasova.mg@mipt.ru'}>
                bekasova.mg@mipt.ru
              </TextLink>
            )
          }
        ]
      },
      {
        title: 'Электронное трудоустройство на портале hr.mipt.ru',
        contacts: [
          {
            title: 'Телефон',
            content: '+7 (498) 713-91-50'
          },
          {
            title: 'Почта',
            content: (
              <TextLink noUnderline href={'mailto:hr-lk@mipt.ru'}>
                hr-lk@mipt.ru
              </TextLink>
            )
          }
        ]
      },
      {
        title: 'Обучение для сотрудников',
        contacts: [
          {
            title: 'Телефон',
            content: '+7 (498) 713-91-44'
          },
          {
            title: 'Почта',
            content: (
              <TextLink noUnderline href={'mailto:hr@mipt.ru'}>
                hr@mipt.ru
              </TextLink>
            )
          }
        ]
      },
      {
        title: 'Конкурс ППС',
        contacts: [
          {
            title: 'Телефон',
            content: '+7 (495) 576-52-11'
          },
          {
            title: 'Почта',
            content: (
              <TextLink noUnderline href={'mailto:hr@mipt.ru'}>
                hr@mipt.ru
              </TextLink>
            )
          }
        ]
      },
      {
        title: 'Вакансии',
        contacts: [
          {
            title: 'Телефон',
            content: '+7 (498) 744-65-51'
          },
          {
            title: 'Почта',
            content: (
              <TextLink noUnderline href={'mailto:hr@mipt.ru'}>
                hr@mipt.ru
              </TextLink>
            )
          },
          {
            title: 'Ресурсы',
            content: (
              <>
                <TextLink noUnderline href={'https://hr.mipt.ru/'}>
                  hr.mipt.ru
                </TextLink>
                <br />
                <TextLink
                  noUnderline
                  href={'https://hh.ru/employer/1008541?hhtmFrom=vacancy'}
                >
                  hh.ru
                </TextLink>
              </>
            )
          }
        ]
      }
    ]
  },
  {
    title: 'Отдел кадров',
    cardSections: [
      {
        title: (
          <ContactsCardPerson
            avatarSrc={personSrcHrFirst}
            profession={'Начальник отдела'}
            name={'Далецкая Ирина Алексеевна'}
          />
        ),
        contacts: [
          {
            title: 'Телефон',
            content: '+7 (495) 408-49-88'
          }
        ]
      },
      {
        title: (
          <ContactsCardPerson
            avatarSrc={personSrcHrSecond}
            profession={'Заместитель начальника отдела'}
            name={'Британ Наталья Владимировна'}
          />
        ),
        contacts: [
          {
            title: 'Телефон',
            content: '+7 (498) 744-65-39'
          }
        ]
      }
    ]
  }
];

export const Contacts = () => {
  return (
    <LandingLayoutContent className={s.Contacts}>
      <LandingGrid className={s.Contacts__headGrid}>
        <LandingGrid.GridItem cols={6}>
          <div className={s.Contacts__title}>Телефоны справочных служб</div>
        </LandingGrid.GridItem>
        <LandingGrid.GridItem cols={6}>
          <div className={s.Contacts__text}>
            <p>
              На сайте{' '}
              <TextLink
                href={'https://mipt.ru/about/general/contacts/phones.php'}
              >
                mipt.ru
              </TextLink>{' '}
              в разделе Телефонный справочник Вы найдете контактные данные
              сотрудников МФТИ, с указанием имён, должностей, телефонных
              номеров, добавочных телефонных номеров и местоположение
              структурных подразделений.
            </p>
            <p>
              <b>Справочная МФТИ:</b> +7 (495) 408 45-54
            </p>
          </div>
        </LandingGrid.GridItem>
      </LandingGrid>

      <LandingGrid className={s.Contacts__itemsGrid}>
        {mainContact.map((item, iItem) => (
          <LandingGrid.GridItem key={iItem} cols={2}>
            <div className={s.Contacts__sectionTitle}>{item.title}</div>
            <ContactsCard sections={item.cardSections} />
          </LandingGrid.GridItem>
        ))}
      </LandingGrid>
      <LandingGrid className={s.Contacts__itemsGrid}>
        {contactsTemp.map((item, iItem) => (
          <LandingGrid.GridItem key={iItem} cols={1}>
            <div className={s.Contacts__sectionTitle}>{item.title}</div>
            <ContactsCard sections={item.cardSections} />
          </LandingGrid.GridItem>
        ))}
      </LandingGrid>
    </LandingLayoutContent>
  );
};
